import { render, staticRenderFns } from "./DefaultEditConfirmation.vue?vue&type=template&id=205dbeb8&lang=pug&"
import script from "./DefaultEditConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DefaultEditConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports